import {Link} from "react-router-dom";
import {Form, FormFeedback, FormGroup, Label, Input, Button} from "reactstrap";
import Logo from '../../assets/images/BX-LOGO.svg'
import {useState} from "react";
import {useMutation} from "@tanstack/react-query";
import {toast} from "react-toastify";
import { useNavigate } from 'react-router-dom'
import Select from 'react-select';
import {waitingList} from "../../api/api";
import Loader from "../../components/Loader";



const COUNTRIES_NOT_ALLOWED_FOR_REGISTRATION = [
    { code: 'AF', name: 'AFGHANISTAN' },
    { code: 'AL', name: 'ALBANIA' },
    { code: 'DZ', name: 'ALGERIA' },
    { code: 'AS', name: 'AMERICAN SAMOA' },
    { code: 'AD', name: 'ANDORRA' },
    { code: 'AO', name: 'ANGOLA' },
    { code: 'AI', name: 'ANGUILLA' },
    { code: 'AQ', name: 'ANTARCTICA' },
    { code: 'AG', name: 'ANTIGUA AND BARBUDA' },
    { code: 'AR', name: 'ARGENTINA' },
    { code: 'AM', name: 'ARMENIA' },
    { code: 'AW', name: 'ARUBA' },
    { code: 'AU', name: 'AUSTRALIA' },
    { code: 'AT', name: 'AUSTRIA' },
    { code: 'AZ', name: 'AZERBAIJAN' },
    { code: 'BS', name: 'BAHAMAS' },
    { code: 'BH', name: 'BAHRAIN' },
    { code: 'BD', name: 'BANGLADESH' },
    { code: 'BB', name: 'BARBADOS' },
    { code: 'BY', name: 'BELARUS' },
    { code: 'BE', name: 'BELGIUM' },
    { code: 'BZ', name: 'BELIZE' },
    { code: 'BJ', name: 'BENIN' },
    { code: 'BM', name: 'BERMUDA' },
    { code: 'BT', name: 'BHUTAN' },
    { code: 'BO', name: 'BOLIVIA' },
    { code: 'BA', name: 'BOSNIA AND HERZEGOVINA' },
    { code: 'BW', name: 'BOTSWANA' },
    { code: 'BV', name: 'BOUVET ISLAND' },
    { code: 'BR', name: 'BRAZIL' },
    { code: 'IO', name: 'BRITISH INDIAN OCEAN TERRITORY' },
    { code: 'BN', name: 'BRUNEI DARUSSALAM' },
    { code: 'BG', name: 'BULGARIA' },
    { code: 'BF', name: 'BURKINA FASO' },
    { code: 'BI', name: 'BURUNDI' },
    { code: 'KH', name: 'CAMBODIA' },
    { code: 'CM', name: 'CAMEROON' },
    { code: 'CA', name: 'CANADA' },
    { code: 'CV', name: 'CAPE VERDE' },
    { code: 'KY', name: 'CAYMAN ISLANDS' },
    { code: 'CF', name: 'CENTRAL AFRICAN REPUBLIC' },
    { code: 'TD', name: 'CHAD' },
    { code: 'CL', name: 'CHILE' },
    { code: 'CN', name: 'CHINA' },
    { code: 'CX', name: 'CHRISTMAS ISLAND' },
    { code: 'CC', name: 'COCOS (KEELING) ISLANDS' },
    { code: 'CO', name: 'COLOMBIA' },
    { code: 'KM', name: 'COMOROS' },
    { code: 'CG', name: 'CONGO' },
    { code: 'CD', name: 'CONGO, THE DEMOCRATIC REPUBLIC OF' },
    { code: 'CK', name: 'COOK ISLANDS' },
    { code: 'CR', name: 'COSTA RICA' },
    { code: 'CI', name: "CÃ”TE D'IVOIRE" },
    { code: 'HR', name: 'CROATIA' },
    { code: 'CU', name: 'CUBA' },
    { code: 'CY', name: 'CYPRUS' },
    { code: 'CZ', name: 'CZECH REPUBLIC' },
    { code: 'DK', name: 'DENMARK' },
    { code: 'DJ', name: 'DJIBOUTI' },
    { code: 'DM', name: 'DOMINICA' },
    { code: 'DO', name: 'DOMINICAN REPUBLIC' },
    { code: 'EC', name: 'ECUADOR' },
    { code: 'EG', name: 'EGYPT' },
    { code: 'SV', name: 'EL SALVADOR' },
    { code: 'GQ', name: 'EQUATORIAL GUINEA' },
    { code: 'ER', name: 'ERITREA' },
    { code: 'EE', name: 'ESTONIA' },
    { code: 'ET', name: 'ETHIOPIA' },
    { code: 'FK', name: 'FALKLAND ISLANDS (MALVINAS)' },
    { code: 'FO', name: 'FAROE ISLANDS' },
    { code: 'FJ', name: 'FIJI' },
    { code: 'FI', name: 'FINLAND' },
    { code: 'FR', name: 'FRANCE' },
    { code: 'GF', name: 'FRENCH GUIANA' },
    { code: 'PF', name: 'FRENCH POLYNESIA' },
    { code: 'TF', name: 'FRENCH SOUTHERN TERRITORIES' },
    { code: 'GA', name: 'GABON' },
    { code: 'GM', name: 'GAMBIA' },
    { code: 'GE', name: 'GEORGIA' },
    { code: 'DE', name: 'GERMANY' },
    { code: 'GH', name: 'GHANA' },
    { code: 'GI', name: 'GIBRALTAR' },
    { code: 'GR', name: 'GREECE' },
    { code: 'GL', name: 'GREENLAND' },
    { code: 'GD', name: 'GRENADA' },
    { code: 'GP', name: 'GUADELOUPE' },
    { code: 'GU', name: 'GUAM' },
    { code: 'GT', name: 'GUATEMALA' },
    { code: 'GN', name: 'GUINEA' },
    { code: 'GW', name: 'GUINEA' },
    { code: 'GY', name: 'GUYANA' },
    { code: 'HT', name: 'HAITI' },
    { code: 'HM', name: 'HEARD ISLAND AND MCDONALD ISLANDS' },
    { code: 'HN', name: 'HONDURAS' },
    { code: 'HK', name: 'HONG KONG' },
    { code: 'HU', name: 'HUNGARY' },
    { code: 'IS', name: 'ICELAND' },
    { code: 'ID', name: 'INDONESIA' },
    { code: 'IR', name: 'IRAN, ISLAMIC REPUBLIC OF' },
    { code: 'IQ', name: 'IRAQ' },
    { code: 'IE', name: 'IRELAND' },
    { code: 'IL', name: 'ISRAEL' },
    { code: 'IT', name: 'ITALY' },
    { code: 'JM', name: 'JAMAICA' },
    { code: 'JP', name: 'JAPAN' },
    { code: 'JO', name: 'JORDAN' },
    { code: 'KZ', name: 'KAZAKHSTAN' },
    { code: 'KE', name: 'KENYA' },
    { code: 'KI', name: 'KIRIBATI' },
    { code: 'KP', name: "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF" },
    { code: 'KR', name: 'KOREA, REPUBLIC OF' },
    { code: 'KW', name: 'KUWAIT' },
    { code: 'KG', name: 'KYRGYZSTAN' },
    { code: 'LA', name: "LAO PEOPLE'S DEMOCRATIC REPUBLIC" },
    { code: 'LV', name: 'LATVIA' },
    { code: 'LB', name: 'LEBANON' },
    { code: 'LS', name: 'LESOTHO' },
    { code: 'LR', name: 'LIBERIA' },
    { code: 'LY', name: 'LIBYAN ARAB JAMAHIRIYA' },
    { code: 'LI', name: 'LIECHTENSTEIN' },
    { code: 'LT', name: 'LITHUANIA' },
    { code: 'LU', name: 'LUXEMBOURG' },
    { code: 'MO', name: 'MACAO' },
    { code: 'MK', name: 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF' },
    { code: 'MG', name: 'MADAGASCAR' },
    { code: 'MW', name: 'MALAWI' },
    { code: 'MY', name: 'MALAYSIA' },
    { code: 'MV', name: 'MALDIVES' },
    { code: 'ML', name: 'MALI' },
    { code: 'MT', name: 'MALTA' },
    { code: 'MH', name: 'MARSHALL ISLANDS' },
    { code: 'MQ', name: 'MARTINIQUE' },
    { code: 'MR', name: 'MAURITANIA' },
    { code: 'MU', name: 'MAURITIUS' },
    { code: 'YT', name: 'MAYOTTE' },
    { code: 'MX', name: 'MEXICO' },
    { code: 'FM', name: 'MICRONESIA, FEDERATED STATES OF' },
    { code: 'MD', name: 'MOLDOVA, REPUBLIC OF' },
    { code: 'MC', name: 'MONACO' },
    { code: 'MN', name: 'MONGOLIA' },
    { code: 'MS', name: 'MONTSERRAT' },
    { code: 'MA', name: 'MOROCCO' },
    { code: 'MZ', name: 'MOZAMBIQUE' },
    { code: 'MM', name: 'MYANMAR' },
    { code: 'NA', name: 'NAMIBIA' },
    { code: 'NR', name: 'NAURU' },
    { code: 'NP', name: 'NEPAL' },
    { code: 'NL', name: 'NETHERLANDS' },
    { code: 'AN', name: 'NETHERLANDS ANTILLES' },
    { code: 'NC', name: 'NEW CALEDONIA' },
    { code: 'NZ', name: 'NEW ZEALAND' },
    { code: 'NI', name: 'NICARAGUA' },
    { code: 'NE', name: 'NIGER' },
    { code: 'NG', name: 'NIGERIA' },
    { code: 'NU', name: 'NIUE' },
    { code: 'NF', name: 'NORFOLK ISLAND' },
    { code: 'MP', name: 'NORTHERN MARIANA ISLANDS' },
    { code: 'NO', name: 'NORWAY' },
    { code: 'OM', name: 'OMAN' },
    { code: 'PK', name: 'PAKISTAN' },
    { code: 'PW', name: 'PALAU' },
    { code: 'PS', name: 'PALESTINIAN TERRITORY, OCCUPIED' },
    { code: 'PA', name: 'PANAMA' },
    { code: 'PG', name: 'PAPUA NEW GUINEA' },
    { code: 'PY', name: 'PARAGUAY' },
    { code: 'PE', name: 'PERU' },
    { code: 'PH', name: 'PHILIPPINES' },
    { code: 'PN', name: 'PITCAIRN' },
    { code: 'PL', name: 'POLAND' },
    { code: 'PT', name: 'PORTUGAL' },
    { code: 'PR', name: 'PUERTO RICO' },
    { code: 'QA', name: 'QATAR' },
    { code: 'RE', name: 'RÉUNION' },
    { code: 'RO', name: 'ROMANIA' },
    { code: 'RU', name: 'RUSSIAN FEDERATION' },
    { code: 'RW', name: 'RWANDA' },
    { code: 'SH', name: 'SAINT HELENA' },
    { code: 'KN', name: 'SAINT KITTS AND NEVIS' },
    { code: 'LC', name: 'SAINT LUCIA' },
    { code: 'PM', name: 'SAINT PIERRE AND MIQUELON' },
    { code: 'VC', name: 'SAINT VINCENT AND THE GRENADINES' },
    { code: 'WS', name: 'SAMOA' },
    { code: 'SM', name: 'SAN MARINO' },
    { code: 'ST', name: 'SAO TOME AND PRINCIPE' },
    { code: 'SA', name: 'SAUDI ARABIA' },
    { code: 'SN', name: 'SENEGAL' },
    { code: 'CS', name: 'SERBIA AND MONTENEGRO' },
    { code: 'SC', name: 'SEYCHELLES' },
    { code: 'SL', name: 'SIERRA LEONE' },
    { code: 'SG', name: 'SINGAPORE' },
    { code: 'SK', name: 'SLOVAKIA' },
    { code: 'SI', name: 'SLOVENIA' },
    { code: 'SB', name: 'SOLOMON ISLANDS' },
    { code: 'SO', name: 'SOMALIA' },
    { code: 'ZA', name: 'SOUTH AFRICA' },
    { code: 'GS', name: 'SOUTH GEORGIA AND SOUTH SANDWICH ISLANDS' },
    { code: 'ES', name: 'SPAIN' },
    { code: 'LK', name: 'SRI LANKA' },
    { code: 'SD', name: 'SUDAN' },
    { code: 'SR', name: 'SURINAME' },
    { code: 'SJ', name: 'SVALBARD AND JAN MAYEN' },
    { code: 'SZ', name: 'SWAZILAND' },
    { code: 'SE', name: 'SWEDEN' },
    { code: 'CH', name: 'SWITZERLAND' },
    { code: 'SY', name: 'SYRIAN ARAB REPUBLIC' },
    { code: 'TW', name: 'TAIWAN, PROVINCE OF CHINA' },
    { code: 'TJ', name: 'TAJIKISTAN' },
    { code: 'TZ', name: 'TANZANIA, UNITED REPUBLIC OF' },
    { code: 'TH', name: 'THAILAND' },
    { code: 'TL', name: 'TIMOR' },
    { code: 'TG', name: 'TOGO' },
    { code: 'TK', name: 'TOKELAU' },
    { code: 'TO', name: 'TONGA' },
    { code: 'TT', name: 'TRINIDAD AND TOBAGO' },
    { code: 'TN', name: 'TUNISIA' },
    { code: 'TR', name: 'TURKEY' },
    { code: 'TM', name: 'TURKMENISTAN' },
    { code: 'TC', name: 'TURKS AND CAICOS ISLANDS' },
    { code: 'TV', name: 'TUVALU' },
    { code: 'UG', name: 'UGANDA' },
    { code: 'UA', name: 'UKRAINE' },
    { code: 'AE', name: 'UNITED ARAB EMIRATES' },
    { code: 'GB', name: 'UNITED KINGDOM' },
    { code: 'US', name: 'UNITED STATES' },
    { code: 'UM', name: 'UNITED STATES MINOR OUTLYING ISLANDS' },
    { code: 'UY', name: 'URUGUAY' },
    { code: 'UZ', name: 'UZBEKISTAN' },
    { code: 'VU', name: 'VANUATU' },
    { code: 'VN', name: 'VIET NAM' },
    { code: 'VG', name: 'VIRGIN ISLANDS, BRITISH' },
    { code: 'VI', name: 'VIR'}
];
function WaitingList() {

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [businessDetails, setBusinessDetails] = useState("");
    const [country, setCountry] = useState(null);
    const [filteredCountries, setFilteredCountries] = useState(COUNTRIES_NOT_ALLOWED_FOR_REGISTRATION);
    const navigate = useNavigate()


    const waitingListMutation = useMutation({
        mutationFn: waitingList,
        onSuccess: (data, variables) =>{
            setFirstName('')
            setLastName('')
            setEmail('')
            setPhone('')
            setBusinessDetails('')
            setCountry({ value: 'AF', label: 'AFGHANISTAN' })

            navigate("/waiting-list-confirmation")
            // tokenRefreshMutation.mutate()
            // const newData = {"results":[{'first_name': 'Vamsi'}]}
            // queryClient.setQueryData(['user'], newData)
            toast.success('Your in a waitinglist')
        },
        onError: err => {
            toast.error(`${err?.response?.data?.email}`)

        }
    })



    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("first_name", firstName);
        formData.append("last_name", lastName);
        formData.append("email", email);
        formData.append("phone", phone);
        formData.append("business_details", businessDetails);
        formData.append("country",country.value)
        waitingListMutation.mutate(formData)
    };
    const handleCountryInputChange = (input) => {
        const filtered = COUNTRIES_NOT_ALLOWED_FOR_REGISTRATION.filter(
            (country) =>
                country.name.toLowerCase().startsWith(input.toLowerCase())
        );
        setFilteredCountries(filtered);
    };

    return (
        <>
            <div className="account-pages mt-5 mb-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6 col-xl-5">
                            <div className="card">
                                <div className="card-body p-4">
                                    <div className="text-center w-75 m-auto">
                                    <span>
                                        <img
                                            src={Logo}
                                            width="73"
                                            height="56"
                                            alt={Logo}
                                        />
                                    </span>
                                        <p className="text-muted mb-4 mt-3">
                                            Get ahead of the curve and join our BlackX waiting list now!
                                        </p>
                                    </div>

                                    <Form onSubmit={handleSubmit}>
                                        <FormGroup className="form-group mb-3">
                                            <Label for="first-name">
                                                First Name
                                                <span className="text-danger">*</span>
                                            </Label>
                                            <Input
                                                className="form-control"
                                                type="text"
                                                id="first-name"
                                                value={firstName}
                                                placeholder="Enter your First Name"
                                                invalid={
                                                    waitingListMutation.isError &&
                                                    waitingListMutation.error.response.data.first_name
                                                }
                                                onChange={(e) => setFirstName(e.target.value)}
                                            />
                                            <FormFeedback invalid>
                                                {waitingListMutation.isError &&
                                                    waitingListMutation.error.response.data.first_name}
                                            </FormFeedback>
                                        </FormGroup>
                                        <FormGroup className="form-group mb-3">
                                            <Label for="last-name">
                                                Last Name
                                                <span className="text-danger">*</span>
                                            </Label>
                                            <Input
                                                className="form-control"
                                                type="text"
                                                id="last-name"
                                                value={lastName}
                                                placeholder="Enter your Last Name"
                                                invalid={
                                                    waitingListMutation.isError &&
                                                    waitingListMutation.error.response.data.last_name
                                                }
                                                onChange={(e) => setLastName(e.target.value)}
                                            />
                                            <FormFeedback invalid>
                                                {waitingListMutation.isError &&
                                                    waitingListMutation.error.response.data.last_name}
                                            </FormFeedback>
                                        </FormGroup>
                                        <FormGroup className="form-group mb-3">
                                            <Label for="email-address">
                                                Email address
                                                <span className="text-danger">*</span>
                                            </Label>
                                            <Input
                                                className="form-control"
                                                type="email"
                                                id="email-address"
                                                value={email}
                                                placeholder="Enter your email address"
                                                invalid={
                                                    waitingListMutation.isError &&
                                                    waitingListMutation.error.response.data.email
                                                }
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                            <FormFeedback invalid>
                                                {waitingListMutation.isError &&
                                                    waitingListMutation.error.response.data.email}
                                            </FormFeedback>
                                        </FormGroup>
                                        <FormGroup className="form-group mb-3">
                                            <Label for="phone">
                                                Phone Number
                                                <span className="text-danger">*</span>
                                            </Label>
                                            <Input
                                                className="form-control"
                                                type="tel"
                                                id="phone"
                                                value={phone}
                                                placeholder="Enter your Phone number"
                                                pattern="[0-9]{10}"
                                                invalid={
                                                    waitingListMutation.isError &&
                                                    waitingListMutation.error.response.data.phone
                                                }
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/[^0-9]/g, '');
                                                    setPhone(value);
                                                }}
                                            />
                                            <FormFeedback invalid>
                                                {waitingListMutation.isError &&
                                                    waitingListMutation.error.response.data.phone}
                                            </FormFeedback>
                                        </FormGroup>
                                        <FormGroup className="form-group mb-3">
                                            <Label for="country">
                                                Country
                                                <span className="text-danger">*</span>
                                            </Label>

                                            <Select
                                                id="country"
                                                options={filteredCountries.map(country => ({value: country.code, label: country.name}))}
                                                value={country}
                                                onChange={selectedOption => setCountry(selectedOption)}
                                                onInputChange={(inputValue) => handleCountryInputChange(inputValue)}
                                                placeholder="Select Your Country"
                                                isClearable
                                                styles={{
                                                    input: (provided) => ({
                                                        ...provided,
                                                        color: 'white', // Input text color
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: '#a8b5c3', // Placeholder color
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        backgroundColor: '#394450',
                                                    }),
                                                    menuList: (provided) => ({
                                                        ...provided,
                                                        color: '#ffffff',
                                                    }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#4d5bed' : 'transparent',

                                                    }),
                                                }}                                    />

                                            <FormFeedback invalid>
                                                {waitingListMutation.isError &&
                                                    waitingListMutation.error.response.data.country}
                                            </FormFeedback>
                                        </FormGroup>
                                        <FormGroup className="form-group mb-3">
                                            <Label for="business-details">
                                                Tell us about your business
                                                <span className="text-danger"></span>
                                            </Label>
                                            <Input
                                                className="form-control"
                                                type="textarea"
                                                id="business-details"
                                                value={businessDetails}
                                                placeholder="Business Details"
                                                invalid={
                                                    waitingListMutation.isError &&
                                                    waitingListMutation.error.response.data.business_details
                                                }
                                                onChange={(e) => setBusinessDetails(e.target.value)}
                                            />
                                            <FormFeedback invalid>
                                                {waitingListMutation.isError &&
                                                    waitingListMutation.error.response.data.business_details}
                                            </FormFeedback>
                                        </FormGroup>

                                        <FormGroup>
                                            <Button
                                                type="submit"
                                                className="btn bx-btn-primary btn-block waves-effect waves-light mt-2"
                                                disabled={waitingListMutation.isLoading}>{waitingListMutation.isLoading? <><Loader size={'small'}/>Submitting...</>: `Submit`} 
                                            </Button>
                                        </FormGroup>
                                    </Form>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12 text-center">
                                    <p className="text-muted">
                                        Already have an account?
                                        <Link
                                            to="/login"
                                            className="text-primary font-weight-medium ml-1"
                                        >
                                            Log In
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default WaitingList;